var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex pb-2 align-start"},[_c('v-icon',{staticClass:"me-2",attrs:{"color":"accent"}},[_vm._v("mdi-check-bold")]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }